import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RegisterResellerPageRoutingModule } from './register-reseller-routing.module';

import { RegisterResellerPage } from './register-reseller.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RegisterResellerPageRoutingModule,
    NgxDatatableModule
    
    
  ],
  declarations: [RegisterResellerPage]
})
export class RegisterResellerPageModule {}
